import { enableVariantIcon } from '../state/ui-store';

export const enableVariantBttn = () => enableVariantIcon();
